import { useMemo, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { Marker } from '@tcc/treadstone';
import L from 'leaflet';

type ReactLeafletMarkerProps = {
  className: string;
  element: ReactNode;
  eventHandlers: L.LeafletEventHandlerFnMap;
  iconSize: number;
  opacity: number;
  position: L.LatLngExpression;
  testId: string;
};

export const ReactLeafletMarker = ({
  className,
  element,
  eventHandlers,
  iconSize,
  opacity,
  position,
  testId,
}: ReactLeafletMarkerProps) => {
  const iconContainer = useMemo(() => document.createElement('div'), []);
  const icon = useMemo(
    () => L.divIcon({
      className,
      html: iconContainer,
      iconSize: [iconSize, iconSize],
    }),
    [className, iconContainer, iconSize]
  );

  return (
    <>
      {createPortal(element, iconContainer)}
      <Marker
        data-test-id={testId}
        eventHandlers={eventHandlers}
        icon={icon}
        opacity={opacity}
        position={position}
      />
    </>
  );
};
